import {SerializedStyles} from '@emotion/react';
import {css, Select, useTheme} from '@mui/material';
import {SelectProps} from '@mui/material/Select/Select';
import React from 'react';

import {DlMuiCaretDownIcon} from './DlMuiCaretDownIcon';
import {GetStylesFunction} from 'src/js/common/types';

interface OwnProps extends SelectProps {
  inputCss?: SerializedStyles;
}

type Props = OwnProps;

export const DlMuiSelect: React.FC<Props> = (props) => {
  const {children, inputCss, ...restProps} = props;
  const theme = useTheme();
  const styles = getStyles({theme, params: {inputCss}});

  return (
    <Select
      data-name={'dl-mui-select--select'}
      IconComponent={DlMuiCaretDownIcon}
      {...restProps}
      css={styles.select}
    >
      {children}
    </Select>
  );
};

DlMuiSelect.displayName = 'DlMuiSelect';

const getStyles: GetStylesFunction = (options) => ({
  select: css`
    height: 24px;
    width: 61px;
    color: ${options?.theme?.palette.custom.coolGray['900']};
    border: 1px solid ${options?.theme?.palette.custom.coolGray['100']};
    border-radius: 4px;
    ${options?.params?.inputCss ?? ''};
  `,
});
